import { Form, Input, ModalProps, FormProps, Modal, InputNumber, Select, useSelect } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import { createUserHistory } from 'gql/mutations'
import { IGradeLevel, IMedium } from 'interfaces'

type EditGradeProps = {
  modalProps: ModalProps
  formProps: FormProps
}

export const EditGrade: React.FC<EditGradeProps> = ({ modalProps, formProps }) => {
  const { data: user } = useGetIdentity()

  const { selectProps: gradeLevelsSelectProps } = useSelect<IGradeLevel>({
    resource: 'grade_levels',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
  const { userRole } = useUserContext()
  const onFinish = async (values: any) => {
    return (
      formProps?.onFinish &&
      formProps?.onFinish({
        ...values,
        updated_by: user?.id
      })
    )

  }
  return (
    <Modal {...modalProps} title="Edit Grade">
      <Form {...formProps} layout="vertical" onFinish={async values => {
        let response = await onFinish(values).then((response: any) => {
          if (response) {
            createUserHistory('grades', 'edit', response?.data?.id, user?.id, userRole)
          }

        })

        return response
      }}>
        {/* <Form.Item
                    label="Medium"
                    name="medium_id"
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <Select {...mediumSelectProps} />
                </Form.Item> */}
        <Form.Item
          label="Grade Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input type="number" />
        </Form.Item>
        <Form.Item
          label="Grade Levels "
          name="grade_levels_id"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select {...gradeLevelsSelectProps} />
        </Form.Item>

        <Form.Item name="updated_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
